export default "__VITE_ASSET__af505a0d__"